module.exports = __webpack_public_path__ + "img/dots.518711b9.svg";